(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/envelope/assets/javascripts/components/content-images.js') >= 0) return;  svs.modules.push('/components/tur/envelope/assets/javascripts/components/content-images.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const Image = svs.content.image_v2.Image;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  memo = _React.memo;
const generateKey = (image, index) => "".concat(image.url, "_").concat(index);
const ImageMemo = memo(_ref => {
  let cssSelectors = _ref.cssSelectors,
    image = _ref.image;
  return React.createElement(Image, {
    cssSelectors: cssSelectors,
    image: image
  });
});
const getAnimationStyle = (i, elements) => {
  const baseRotation = 7;
  const isEven = i % 2 === 0;
  const isOddElementCount = elements.length % 2 === 1;
  if (elements.length === 1 || isOddElementCount && elements.length > 2 && i === 0) {
    return {
      y: -35,
      left: '50%',
      rotation: baseRotation
    };
  }
  const rotation = isEven ? -baseRotation : baseRotation;
  const leftOffset = rotation + 50;
  return {
    rotation,
    left: "".concat(leftOffset, "%"),
    y: -50
  };
};
const animate = (wrapperEl, split) => {
  const elements = wrapperEl.querySelectorAll('.envelope-content-animation');
  if (split) {
    elements.forEach((el, i) => {
      gsap.to(el, _objectSpread({
        duration: 1,
        ease: 'elastic.out(1,0.3)'
      }, getAnimationStyle(i, elements)));
    });
  } else {
    gsap.to(elements, {
      duration: 1,
      ease: 'elastic.out(1,0.3)',
      y: -35,
      rotation: 7
    });
  }
};
const ContentImages = _ref2 => {
  let images = _ref2.images,
    split = _ref2.split;
  const contentImgRef = useRef(null);
  const imgCountRef = useRef(null);
  useEffect(() => {
    const shouldAnimate = images.length !== imgCountRef.current;
    if (contentImgRef.current && shouldAnimate) {
      imgCountRef.current = images.length;
      animate(contentImgRef.current, split);
    }
  }, [images.length, contentImgRef.current]);
  useEffect(() => {
    if (contentImgRef.current) {
      contentImgRef.current.style.setProperty('--number-of-images', Math.min(images.length, 5));
    }
  }, [images.length]);
  return React.createElement("div", {
    className: "content-images",
    ref: contentImgRef
  }, images.map((image, index) => {
    const cls = ['content-image', 'envelope-content-animation'];
    if (image.width > image.height) {
      cls.push('wide');
    }
    return React.createElement(ImageMemo, {
      cssSelectors: cls.join(' '),
      image: image,
      key: generateKey(image, index)
    });
  }));
};
setGlobal('svs.tur.envelope.components.ContentImages', ContentImages);

 })(window);